module.exports = __webpack_public_path__ + "img/gitee.2a02ae3e.svg";